import { input, output } from '@b2b/types/core';
import angular, { INgModelController } from 'angular';

let id = 0;

interface FilterbarSubmitEvent {
  model: string;
}

class FilterbarController {
  static $inject = ['$element'];

  ngModel = input<string>();
  ngModelCtrl!: INgModelController;
  loading = input<boolean>();
  disabled = input<boolean>();
  label = input<string>();
  placeholder = input<string>();
  submit = output<FilterbarSubmitEvent>();

  id = `acme-filterbar-${++id}`;

  constructor(private $element: JQuery) {}

  $onInit() {
    this.$element.addClass('acme-filterbar');
  }

  ngModelChange() {
    this.ngModelCtrl.$setViewValue(this.ngModel);
  }
}

export const FilterbarComponentModule = angular
  .module('acme.common.component.filterbar', [])
  .component('acmeFilterbar', {
    templateUrl: 'common/components/filterbar/filterbar.component.tpl.html',
    controller: FilterbarController,
    require: {
      ngModelCtrl: 'ngModel',
    },
    bindings: {
      ngModel: '<',
      loading: '<',
      disabled: '<',
      label: '<',
      placeholder: '<',
      submit: '&',
    },
  }).name;
